import { useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { AgGridReact } from "ag-grid-react";
import { Content_PUR1021_R01 } from "./Content_PUR1021_R01";
import { PUR1021_R01HeaderDto, PUR1021_R01PurchaseDto, PUR1021_R01SuppliedDto } from "./Dto_PUR1021_R01";
import { SearchSection_PUR1021_R01 } from "./SearchSection_PUR1021_R01";
import { usePUR1021_R01Store } from "./Store_PUR1021_R01";
import { Table_PUR1021_R01 } from "./Table_PUR1021_R01";
import { PurchaseTable_PUR1021_R01 } from "./PurchaseTable_PUR1021_R01";
import { SuppliedTable_PUR1021_R01 } from "./SuppliedTable_PUR1021_R01";


export const Container_PUR1021_R01 = () => {

	const { 
		allCount,
		initData, 
    } = usePUR1021_R01Store();

	const { tabList, setMessage } = useUiuxStore();

    const RESIZER = {
        code: 'PUR1021_R01',
		type: 'width',
        storageKey: 'PUR1021_R01-split-width',
		min: 5,
		max: 80,
		default: 55
	} as const;
    const gridRef = useRef<AgGridReact<PUR1021_R01HeaderDto>>(null); 
    const purchaseGridRef = useRef<AgGridReact<PUR1021_R01PurchaseDto>>(null);
	const suppliedGridRef = useRef<AgGridReact<PUR1021_R01SuppliedDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	
	const V_RESIZER = {
		code: 'PUR1021_R01',
		type: 'height',
		storageKey: 'PUR1021_R01-info-split-height',
		min: 5,
		max: 80,
		default: 45
	} as const;
	const rightTopRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		handleExcelClick,
		handleFetchClick,
		handlePUR1030ProcessClick,
		handleWMS1131ProcessClick,
    } = Content_PUR1021_R01({
		gridRef,
		purchaseGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	});

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={handleFetchClick}
			onCreateClick={()=>{}}
			onDeleteClick={ ()=>{}}
			onSaveClick={()=>{}}
			onPrintClick={()=>{}}
			onExcelClick={handleExcelClick}
			onInitClick={() => { initData(); } }
		/>
        <SearchSection_PUR1021_R01 />

		<div className="flex flex-1 px-[12px] gap-[4px] p-[10px]" ref={containerRef} >
			<div className="w-full" style={{ width: `${splitValue}%` }}>
                <Table_PUR1021_R01 gridRef={gridRef} />
			</div>
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이즈"
			/>
			
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
					<div style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
						<PurchaseTable_PUR1021_R01 gridRef={purchaseGridRef} handlePUR1030ProcessClick={handlePUR1030ProcessClick} />
					</div>
					{/* 리사이저 */}
					<div
						className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
						onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
					/>
					<div style={{ height: `${100 - vSplitValue}%` }}>
						<SuppliedTable_PUR1021_R01 gridRef={suppliedGridRef} handleWMS1131ProcessClick={handleWMS1131ProcessClick} />
					</div>
				</div>
		</div>
		<Message />
	</div>
}
